import { Injectable } from '@angular/core';
import { FormActionHandlerService } from './base.service';
import { FormDataService } from '../data.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { FormStatusService } from '../status.service';
import { UserContextService } from '../../../user/services/user-context.service';
import { formStatuses, formTypes } from '../../../form/form.constants';
import { FormShareService } from '../share.service';
import { Subscription } from 'rxjs';
import { PublishSubscribeService } from '../../../fastlane-common/services/publish-subscribe.service';
import { ScheduledEmail } from '../../../email/interfaces/scheduled-email.interface';
import { EmailParameters } from '../../../email/models/email-parameters.model';
import { EmailService } from '../../../email/services/email.service';
import { publishSubscribeEventStrings } from '../../../fastlane-common/event/event.constants';
import { incentiveCategory } from '../../../project/project.constants';
import { AttachmentsService } from '../../../project/services/attachments.service';
import {showApplicationRedirectIfApplicable} from '../../../project/project.functions';
import {FormIdentifier} from '../../../project/models/form-identifier.model';
import {NavService} from '../../../fastlane-common/services/nav.service';

@Injectable()
export class SaveFormActionHandlerService extends FormActionHandlerService {
  subs: Subscription[] = [];
  constructor(
    public attachmentService: AttachmentsService,
    private dataService: FormDataService,
    private shareService: FormShareService,
    private statusService: FormStatusService,
    private swal: SwalService,
    private userContext: UserContextService,
    public pubSubService: PublishSubscribeService,
    public emailService: EmailService,
    public navService: NavService
  ) {
    super();
  }

  exec(): Promise<any> {
    const that = this;
    // Set form status to pending payment when amountDue > 0 when saving an audit.
    // const newStatus =
    //   this.userContext.isUserManager() &&
    //   (this.shareService.form.type ===
    //     formTypes.balanceAdjustmentRequest.abbrev ||
    //     (this.shareService.form.type === formTypes.audit.abbrev &&
    //       this.shareService.form.fees[0].amountDue > 0))
    //     ? formStatuses.pendingPayment.name
    //     : formStatuses.pending.name;

    const newStatus =
      this.userContext.isUserManager() &&
      this.shareService.form.type === formTypes.balanceAdjustmentRequest.abbrev
        ? formStatuses.pendingPayment.name
        : formStatuses.pending.name;
    that.subs.push(
      that.pubSubService
        .on(publishSubscribeEventStrings.principal_photography_uploaded)
        .subscribe(() => {
          const params = <EmailParameters>{};
          params.formId = that.shareService.formId;
          const scheduledEmail = <ScheduledEmail>{};
          scheduledEmail.emailParameters = params;
          scheduledEmail.type = 'Principal Photography Start Due Date';
          that.emailService.cancelScheduledEmails(scheduledEmail).subscribe();
        })
    );

    return new Promise((resolve, reject) => {
      if (
        incentiveCategory.entertainment.incentivePrograms.includes(
          this.shareService.project.projectInfo.incentiveProgram
        ) && this.shareService.form.type === formTypes.balanceAdjustmentRequest.abbrev
      ) {
        that.statusService.changeStatus(newStatus);
      }
      var date = new Date(Date.now());
      this.shareService.form.modifiedDate = date;
      that.swal.load('Saving your form...', 'This will only take a second.');
      that.dataService.saveForm().subscribe(
        successfulSave => {
            that.swal.success({ title: "Successfully saved form!" })
              .then(() => {
                resolve();
              })
              .catch(resolve);
        },
        error => {
          if (error === 409) {
            reject(error);
          } else {
            reject('An error occurred while saving your project.');
          }
        }
      );
    });
  }
}
